// client/src/services/dashboardAPI.js

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

class DashboardAPI {
  
  /**
   * Obtener lista de abuelos del familiar
   */
  async getFamiliarAbuelos(token) {
    try {
      const response = await fetch(`${API_URL}/api/abuelos`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Error obteniendo abuelos');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error en getFamiliarAbuelos:', error);
      throw error;
    }
  }
  
  /**
   * Obtener estadísticas del abuelo
   */
  async getAbueloStats(abueloId, token) {
    try {
      const response = await fetch(`${API_URL}/api/abuelos/${abueloId}/estadisticas`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Error obteniendo estadísticas');
      }
      const data = await response.json();
      
      // Usar los sentimientos REALES del backend
      return {
        id: abueloId,
        nombre: data.nombre || 'Abuelo',
        apellidos: data.apellidos || '',
        telefono: data.telefono || '',
        foto_url: data.foto_url || null,
        plan: data.plan_nombre || 'Sin plan',
        totalConversaciones: parseInt(data.total_conversaciones) || 0,
        minutosTotales: data.minutos_totales || 0,
        ultimaActividad: data.ultima_conversacion
          ? new Date(data.ultima_conversacion).toLocaleDateString('es-ES')
          : 'Nunca',
        indicadorSoledad: data.ultimo_reporte?.indicador_soledad || 0,
        estadoEmocional: data.ultimo_reporte?.estado_animo || 'Sin datos',
        sentimientos: data.sentimientos || {},
        ultimoReporte: data.ultimo_reporte || null
      };
    } catch (error) {
      console.error('Error en getAbueloStats:', error);
      throw error;
    }
  }  
  /**
   * Obtener conversaciones del abuelo
   */
  async getConversations(abueloId, token, limit = 10) {
    try {
      const response = await fetch(
        `${API_URL}/api/abuelos/${abueloId}/conversaciones?limit=${limit}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      if (!response.ok) {
        throw new Error('Error obteniendo conversaciones');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error en getConversations:', error);
      throw error;
    }
  }
  
  /**
   * Obtener alertas del abuelo
   */
  async getAlerts(abueloId, token) {
    try {
      // Por ahora retornamos un array vacío ya que no hay sistema de alertas implementado
      return [];
    } catch (error) {
      console.error('Error en getAlerts:', error);
      throw error;
    }
  }
}

export const dashboardAPI = new DashboardAPI();
